import api from "./api";

/**
 * Email Testing Service
 * Permite enviar correos de prueba para validar la integración con Resend
 */

export const emailTestService = {
  /**
   * Envía un correo de prueba
   * @param {string} email - Email de destino
   * @param {string} nombre - Nombre del destinatario
   * @param {string} username - Username de prueba
   * @param {string} password - Contraseña de prueba
   * @returns {Promise} Respuesta de Resend
   */
  sendTestEmail: async (
    email,
    nombre = "Usuario Test",
    username = "test.user",
    password = "test123",
  ) => {
    try {
      const response = await api.post("/colaboradores/test_email.php", {
        email,
        nombre,
        username,
        password,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Envía un correo de bienvenida real (igual que en crear colaborador)
   * @param {string} email
   * @param {string} nombre
   * @param {string} username
   * @param {string} password
   * @returns {Promise}
   */
  sendWelcomeEmail: async (email, nombre, username, password) => {
    try {
      const response = await api.post("/colaboradores/welcome_email.php", {
        email,
        nombre,
        username,
        password,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default emailTestService;
